<template>
    <div>
      <iframe :src="loginout" hidden></iframe>
    </div>
</template>

<script>
import url from "../../service/base-url.js";
import { storage } from "../../service/storage.js";
export default {
  data() {
    return {
      loginout: ""
    };
  },
  mounted() {
    try {
      this.loginout = `${url.base}/api/account/logout`;
      setTimeout(() => {
        window.location.href = "https://ylw.nxin.com";
      }, 2000);
    } catch (error) {
      console.log(error);
    }
  }
};
</script>

<style>
</style>
